/*
 * @format
 */

import React from 'react';

import Steps from './Steps';
import WatchSetpointTapDiagram from './WatchSetpointTapDiagram';
import WatchSetpointDiagram from './WatchSetpointDiagram';

/*
 * Changing the temperature takes two screens on the watch — open the editor
 * from the zone screen, then dial the target and save — so the topic is told as
 * two steps, one screen each.
 *
 * The sentences of the topic's copy are split over the steps they belong to
 * instead of both steps repeating the whole paragraph: the reader is being told
 * what to do on the screen in front of them. The crown sentence goes with the
 * second step, which is the only one that has a crown drawn on it.
 */
const steps = [
  {
    body:
      'You can change the target temperature for a zone by tapping on the ' +
      'upper half of the screen.',
    diagram: <WatchSetpointTapDiagram />,
  },
  {
    body:
      'You can then increase/decrease your target temperature. If your watch ' +
      'has a crown or bezel you can use this to change the temperature.',
    diagram: <WatchSetpointDiagram />,
  },
];

function WatchAppHelpTemperatureScreen({ navigation }) {
  return (
    <Steps
      title="Changing target temperature"
      steps={steps}
      navigation={navigation}
    />
  );
}

export default WatchAppHelpTemperatureScreen;
